// import { flatten } from 'lodash'
import { Fragment, useEffect, useState } from 'react'
import { API } from '../../apis/API'
import {
    formatOfferPrice,
    getLevelPrices,
    levels,
    // processROSData,
} from '../../helpers/ros'
import {
    _CUSTOM_OFFER__KEY,
    classNames,
    formatPrice,
    getErrorMessage,
    log,
} from '../../helpers/utils'
import { CsvStore } from '../../state/CsvStore'
import { ModalStore } from '../../state/ModalStore'
import ErrorAlert from '../Alerts/ErrorAlert'
import InfoAlert from '../Alerts/InfoAlert'
import CancelButton from '../Buttons/CancelButton'
import ModalMainWrapper from './ModalMainWrapper'
import ModalContentWrapper from './ModalContentWrapper'
import ModalContent from './ModalContent'
import ModalHeader from './ModalHeader'
import ModalFooter from './ModalFooter'

/**
 *
 * @TODO should cache results incase user check again
 */
export default function ROSOffersModal({ onFinish }) {
    const skimModal = ModalStore((state) => state.skim)
    const files = CsvStore((state) => state.files)

    const [offers, setOffers] = useState([])
    const [offer, setOffer] = useState(null)
    const [error, setError] = useState(null)
    const [customOffer, setCustomOffer] = useState(null)
    const [shouldShowReloadButton, setShouldShowReloadButton] = useState(false)

    const offersArray = [1, 2, 3, 4, _CUSTOM_OFFER__KEY]

    function handleFinish() {
        if (!offer) {
            setError('Please select an offer')
            return
        }

        // this custom
        if (offer == _CUSTOM_OFFER__KEY) {
            if (!customOffer) {
                setError('Please enter a custom offer')
                return
            }
        }

        skimModal()
        const offerPercentage =
            offer == _CUSTOM_OFFER__KEY ? customOffer : levels[offer]
        onFinish({ offer, offerPercentage })
    }

    const handleOffer = (value) => {
        setOffer(value)
    }

    async function fetchOffers(filteredRecords) {
        let offersData = [] // Initialize an empty array to store the responses
        for (let i = 0; i < filteredRecords.length; i += 2) {
            // Prepare an array of one or two records depending on availability
            const recordsBatch = filteredRecords.slice(i, i + 2)
            // Send the API request for the batch
            const response = await API.getRosOffers(recordsBatch)
            // Spread the data part of the response and push it to offersData array
            offersData.push(...response.data)
        }
        return offersData // Optionally return the collected data
    }

    const handleROS = async () => {
        setError(null)
        setOffers([])
        setShouldShowReloadButton(false)

        /**
         * @TODO Should check if we have at least 5
         */
        try {
            // const records = flatten(
            //     files.map((file, index) => {
            //         const { data } = file
            //         if (index === 0) {
            //             return data.valids.slice(1, 6)
            //         }
            //     }),
            // )
            /**
             * @TODO Should we make sure we have at least 5 from any other file incase ?
             */
            const firstFile = files[0]
            // we send 15 because there might be some records which does not have a EstimatedValue
            // const records = firstFile.data.valids.slice(1, 15)
            const allRecords = firstFile.data.valids
            const shuffledRecords = Array.from(allRecords).sort(
                () => 0.5 - Math.random(),
            )
            const records = shuffledRecords.slice(0, 12)
            log('records', records)
            const filteredRecords = records.filter(
                (record) => !String(record.propaddres).includes('propaddres'),
            )
            log('filtered records', filteredRecords)
            const offersData = await fetchOffers(filteredRecords)
            log('offersData', offersData)
            if (offersData.length == 0) {
                throw new Error('No Valid offers found, try again.')
            }
            setOffers(offersData)
        } catch (e) {
            log(e)
            setShouldShowReloadButton(true)
            setError(getErrorMessage(e))
        }
    }

    const handleCustomOfferInput = (e) => {
        const value = e.target.value
        setCustomOffer(value)
    }

    const handleOfferValue = (EstimatedValue, item) => {
        if (item == _CUSTOM_OFFER__KEY)
            return formatOfferPrice(
                EstimatedValue * (parseFloat(customOffer) / 100),
            )
        return formatOfferPrice(getLevelPrices(EstimatedValue)[item])
    }

    useEffect(() => {
        handleROS()
    }, [])

    return (
        <ModalMainWrapper>
            <ModalContentWrapper size="4xl">
                <ModalHeader title="Choose your offer" />
                <ModalContent spacing="normal" scroll={true}>
                    <div className="mx-auto">
                        <div className="">
                            {offers.length > 0 ? (
                                <>
                                    <div className="overflow-x-auto">
                                        <table className="w-full border-collapse text-[13px]">
                                            <thead>
                                                <tr>
                                                    <th className="border border-[#ECE6DC] bg-[#FBF8F3] px-3 py-[10px] text-left text-[12.5px] font-bold text-[#1A1D23]">
                                                        Property
                                                    </th>
                                                    {offersArray.map((item) => (
                                                        <th
                                                            key={item}
                                                            className="border border-[#ECE6DC] bg-[#FBF8F3] px-2 py-[10px] text-center text-[12.5px] font-bold text-[#1A1D23]">
                                                            {item ===
                                                            _CUSTOM_OFFER__KEY ? (
                                                                'Custom'
                                                            ) : (
                                                                <>
                                                                    Offer {item}
                                                                    <span className="mt-1 block text-[11px] font-medium text-[#6B7280]">
                                                                        {parseFloat(
                                                                            formatPrice(
                                                                                levels[
                                                                                    item
                                                                                ],
                                                                                2,
                                                                            ),
                                                                        ) * 100}
                                                                        % of
                                                                        value
                                                                    </span>
                                                                </>
                                                            )}
                                                        </th>
                                                    ))}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td className="border border-[#ECE6DC] bg-[#FBF8F3] px-3 py-[10px] text-left text-[12.5px] font-bold text-[#1A1D23]">
                                                        Choose level
                                                    </td>
                                                    {offersArray.map((item) => (
                                                        <td
                                                            key={item}
                                                            onClick={() =>
                                                                item !==
                                                                    _CUSTOM_OFFER__KEY &&
                                                                handleOffer(
                                                                    item,
                                                                )
                                                            }
                                                            className={classNames(
                                                                'border border-[#ECE6DC] bg-[#FBF8F3] px-2 py-[10px] text-center text-[12.5px] text-[#1A1D23]',
                                                                item !==
                                                                    _CUSTOM_OFFER__KEY &&
                                                                    'cursor-pointer hover:bg-[#FDF4EC]',
                                                                offer ===
                                                                    item &&
                                                                    'bg-[#FDF4EC]',
                                                            )}>
                                                            {item ===
                                                            _CUSTOM_OFFER__KEY ? (
                                                                <div className="flex items-center justify-center gap-2">
                                                                    <input
                                                                        type="radio"
                                                                        name="offer"
                                                                        checked={
                                                                            offer ===
                                                                                _CUSTOM_OFFER__KEY ||
                                                                            Boolean(
                                                                                customOffer,
                                                                            )
                                                                        }
                                                                        onChange={() =>
                                                                            handleOffer(
                                                                                _CUSTOM_OFFER__KEY,
                                                                            )
                                                                        }
                                                                    />
                                                                    <input
                                                                        max={
                                                                            100
                                                                        }
                                                                        min={0}
                                                                        type="number"
                                                                        value={
                                                                            customOffer ||
                                                                            ''
                                                                        }
                                                                        onClick={(
                                                                            event,
                                                                        ) =>
                                                                            event.stopPropagation()
                                                                        }
                                                                        onChange={(
                                                                            event,
                                                                        ) => {
                                                                            handleOffer(
                                                                                _CUSTOM_OFFER__KEY,
                                                                            )
                                                                            handleCustomOfferInput(
                                                                                event,
                                                                            )
                                                                        }}
                                                                        className="w-[72px] rounded-[6px] border border-[#E1DACE] px-2 py-[5px] text-center text-[12.5px] text-[#1A1D23] focus:border-[#F28230] focus:outline-none"
                                                                        placeholder="%"
                                                                    />
                                                                </div>
                                                            ) : (
                                                                <div className="flex items-center justify-center gap-2">
                                                                    <input
                                                                        type="radio"
                                                                        name="offer"
                                                                        checked={
                                                                            offer ===
                                                                            item
                                                                        }
                                                                        onChange={() =>
                                                                            handleOffer(
                                                                                item,
                                                                            )
                                                                        }
                                                                    />
                                                                    <span>
                                                                        {parseFloat(
                                                                            formatPrice(
                                                                                levels[
                                                                                    item
                                                                                ],
                                                                                2,
                                                                            ),
                                                                        ) * 100}
                                                                        %
                                                                    </span>
                                                                </div>
                                                            )}
                                                        </td>
                                                    ))}
                                                </tr>
                                                {offers.map(
                                                    ({
                                                        EstimatedValue,
                                                        Address,
                                                        RecordID,
                                                    }) => (
                                                        <tr key={RecordID}>
                                                            <td className="border border-[#ECE6DC] px-3 py-[10px] text-left text-[12.5px] text-[#1A1D23]">
                                                                {Address}
                                                            </td>
                                                            {offersArray.map(
                                                                (item) => {
                                                                    const isSelected =
                                                                        offer ===
                                                                            item &&
                                                                        item !==
                                                                            _CUSTOM_OFFER__KEY
                                                                    return (
                                                                        <td
                                                                            key={
                                                                                item
                                                                            }
                                                                            onClick={() =>
                                                                                item !==
                                                                                    _CUSTOM_OFFER__KEY &&
                                                                                handleOffer(
                                                                                    item,
                                                                                )
                                                                            }
                                                                            className={classNames(
                                                                                'border border-[#ECE6DC] px-2 py-[10px] text-center text-[13px] text-[#1A1D23]',
                                                                                item !==
                                                                                    _CUSTOM_OFFER__KEY &&
                                                                                    'cursor-pointer hover:bg-[#FDF4EC]',
                                                                                isSelected &&
                                                                                    'bg-[#FDF4EC]',
                                                                            )}>
                                                                            {handleOfferValue(
                                                                                EstimatedValue,
                                                                                item,
                                                                            )}
                                                                        </td>
                                                                    )
                                                                },
                                                            )}
                                                        </tr>
                                                    ),
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </>
                            ) : (
                                !shouldShowReloadButton && (
                                    <InfoAlert info="Loading Offers..." />
                                )
                            )}
                        </div>
                    </div>

                    {error && <ErrorAlert error={error} />}

                    {/* <div className="flex justify-center mt-6 space-x-2">
                                    {shouldShowReloadButton ? (
                                        <CancelButton
                                            data-button-id="confirm-cancel"
                                            onClick={handleFinish}
                                            text="Reload Offers"
                                        />
                                    ) : (
                                        <Primary
                                            data-button-id="confirm-button"
                                            onClick={handleFinish}>
                                            Choose Offer
                                        </Primary>
                                    )}
                                </div> */}

                    {shouldShowReloadButton ? (
                        <div className="flex justify-center mt-6 space-x-2 border-t-2 pt-4 border-olm">
                            <CancelButton
                                onClick={handleROS}
                                text="Reload Offers"
                            />
                        </div>
                    ) : (
                        <ModalFooter
                            confirmText="Choose Offer"
                            onConfirm={handleFinish}
                        />
                    )}
                </ModalContent>
            </ModalContentWrapper>
        </ModalMainWrapper>
    )
}
